<template>
  <div class="brokers-holding-proportion rk-section">
    <MoreTitle title="经纪商持股比例" />
    <BrokerList :total="10" />
  </div>
</template>

<script>
import BrokerList from './BrokerList'
export default {
  components: { BrokerList },
  data() {
    return {
      tipVisible: false
    }
  },
  methods: {
    changeRouter() {
      this.$router.push({
        path: '/bidask/brokers',
        query: {
          symbol: this.$route.query.symbol
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.brokers-holding-proportion {
  margin-top: 10px;
  background: var(--bg-color-2);
}
</style>
